import { render, staticRenderFns } from "./FeaturesManager.vue?vue&type=template&id=20e3eb5e&scoped=true"
import script from "./FeaturesManager.vue?vue&type=script&lang=js"
export * from "./FeaturesManager.vue?vue&type=script&lang=js"
import style0 from "./FeaturesManager.vue?vue&type=style&index=0&id=20e3eb5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e3eb5e",
  null
  
)

export default component.exports